import Modal from '@ui-kit/components/modal';
import { t } from '@base/utils/helpers';
import React, { ReactNode } from 'react';
import CloseTable from './closeTable';
import GameModalContent from '../constants/constants';
import Resign from './resign';
import AbortGame from './abortGame';
import EmailGame from './emailGame';
import { BaseGameState } from '@base/features/game/model/interfaces';
import styles from '../styles/gameMenuModal.module.scss';

type ModalContent = {
  title: string,
  body: ReactNode
}

export default function GameMenuModal(props: {
  closeModal: () => void;
  content: GameModalContent;
  gameState?: BaseGameState;
}) {
  const content: Record<GameModalContent, ModalContent> = {
    [GameModalContent.ABORT_GAME]: {
      title: t('abort'),
      body: <AbortGame closeModal={props.closeModal} />,
    },
    [GameModalContent.CLOSE_TABLE]: {
      title: t('close_table'),
      body: (<CloseTable closeModal={props.closeModal} />),
    },
    [GameModalContent.RESIGN]: {
      title: t('resign'),
      body: <Resign closeModal={props.closeModal} />,
    },
    [GameModalContent.EMAIL_GAME]: {
      title: t('email_game'),
      body: <EmailGame closeModal={props.closeModal} gameState={props.gameState!}/>,
    },
  };

  return (
    <Modal
      title={content[props.content].title}
      closeModal={props.closeModal}
      headerBtn
      classes={{ body: styles.gameModal }}
    >
      <div className={styles.content}>{content[props.content].body}</div>
    </Modal>
  );
}
